import React from "react";
import { Link } from "react-router-dom";
import styles from "./Product.module.css";
import { ProductNotFoundStateProps } from "@model/Products.model";
import ExclamationIcon from "Utils/Assets/SVGs/ExclamationIcon";

const ProductNotFoundState: React.FC<ProductNotFoundStateProps> = ({
  className = "",
}) => {
  return (
    <section
      className={`${styles.notFoundSP} ${className}`}
      data-testid="product-not-found"
      aria-labelledby="product-not-found-title"
    >
      <div className={styles.notFoundCardSP} data-testid="product-not-found-card">
        
        <ExclamationIcon
          className={styles.notFoundIconSP}
          data-testid="product-not-found-icon"
        />

        <h1
          id="product-not-found-title"
          className={styles.notFoundTitleSP}
          data-testid="product-not-found-title"
        >
          Product not found
        </h1>

        <p className={styles.notFoundTextSP} data-testid="product-not-found-text">
          The product you’re looking for was not found or may have been removed
          from our catalog.
        </p>

        <p
          className={styles.notFoundTextSecondarySP}
          data-testid="product-not-found-subtext"
        >
          You can browse our shop to discover other automation solutions and
          integrations tailored to your needs.
        </p>

        <div className={styles.notFoundActionsSP} data-testid="product-not-found-actions">
          <Link
            to="/products"
            className={styles.notFoundPrimaryLinkSP}
            data-testid="product-not-found-browse"
          >
            Browse products
          </Link>

          <Link
            to="/"
            className={styles.notFoundSecondaryLinkSP}
            data-testid="product-not-found-home"
          >
            Back to home
          </Link>
        </div>
      </div>
    </section>
  );
};

export default ProductNotFoundState;
